import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/en';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { Provider } from 'react-redux';

import translations from '../../translations';
import MuiXLicense from '../licensing/MuiXLicense';
import redux from './redux';
import BannerManager from './views/banner-manager';
import BulkPauseUnpauseButton from './views/bulk-pause-unpause-button';
import BulkPauseUnpauseModal from './views/bulk-pause-unpause-modal';

export type BulkPauseUnpauseModalProps = {
  customer_group_id: null | number;
  customer_id: number;
  userTimezone: string;
};

const BulkPauseUnpauseContainer = (props: BulkPauseUnpauseModalProps) => {
  const [translationLoaded, setTranslationLoaded] = useState(false);

  useEffect(() => {
    if (!translationLoaded) {
      translations.init((error) => {
        setTranslationLoaded(!error);
      });
    }
  }, []);
  if (!translationLoaded) {
    return null;
  }

  return (
    <>
      <Provider store={redux.store}>
        <LocalizationProvider adapterLocale="en" dateAdapter={AdapterDayjs}>
          <>
            <BulkPauseUnpauseButton />
            <BannerManager />
            <BulkPauseUnpauseModal {...props} />
          </>
        </LocalizationProvider>
      </Provider>
      <MuiXLicense />
    </>
  );
};

export default BulkPauseUnpauseContainer;
